<template>
    <div class="advanced-filter-chain-input display-flex align-items-center">
        <div
            v-if="!showInput"
            class="advanced-filter-chain-input__trigger p-sm display-flex align-items-center justify-between"
            @click="showCorrespondingInput"
        >
            <font-awesome-icon
                class="mr-xs"
                :class="{ 'text-moat-600': finalFilterInput }"
                icon="fas fa-circle-question"
            />
            <p
                class="advanced-filter-chain-input__selected text-truncate"
                :class="{ 'text-moat-600': finalFilterInput }"
            >
                {{ finalFilterInput ? finalFilterInput : placeholder }}
            </p>
        </div>
        <div v-if="showInput && props.type === 'text'" class="display-flex align-items-center">
            <input
                ref="stringInputRef"
                class="advanced-filter-chain-input__input"
                type="text"
                v-model="stringInput"
                @keyup="updateInput"
            />
        </div>
        <div v-if="showInput && props.type === 'number'" class="display-flex align-items-center">
            <input
                ref="numberInputRef"
                class="advanced-filter-chain-input__input"
                type="number"
                v-model="numberInput"
                @keyup="updateInput"
            />
        </div>
        <div v-if="showInput && props.type === 'date'" class="display-flex align-items-center">
            <MoatDatePickerRange
                ref="dateInputRef"
                :type="dateScope"
                blank-state
                @update:modelValue="updateInput"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, watch, defineEmits, nextTick, computed } from 'vue'
import MoatDatePickerRange from '@/components/company/proTabs/helpers/MoatDatePickerRange.vue'

const props = defineProps({
    placeholder: {
        type: String,
        default: '  Select an option',
    },
    type: {
        type: String,
    },
    operator: {
        type: String,
    },
})

const emit = defineEmits(['update:modelValue'])

const showInput = ref(false)

const finalFilterInput = ref('')

const stringInput = ref('')
const stringInputRef = ref(null)
const numberInput = ref('')
const numberInputRef = ref(null)
const dateInput = ref([])
const dateInputRef = ref(null)

const showCorrespondingInput = () => {
    showInput.value = true
}

watch(showInput, async (val) => {
    if (val) {
        await nextTick()
        if (props.type === 'text') {
            stringInputRef.value?.focus()
        } else if (props.type === 'number') {
            numberInputRef.value?.focus()
        } else if (props.type === 'date') {
            dateInputRef.value?.openMenu?.()
        }
    }
})

const dateScope = computed(() => {
    return props.operator === 'inRange' ? 'dateRange' : 'date'
})

const updateInput = (value) => {
    if (props.type === 'text') {
        emit('update:modelValue', stringInput.value)
        finalFilterInput.value = stringInput.value
    } else if (props.type === 'number') {
        emit('update:modelValue', numberInput.value)
        finalFilterInput.value = numberInput.value
    } else if (props.type === 'date') {
        emit('update:modelValue', value)
        finalFilterInput.value = value
    }
}
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.advanced-filter-chain-input {
    position: relative;
    width: 100%;
    max-width: 250px;

    &__trigger {
        height: 40px;
        border-top: 1px solid var(--color-stone-400);
        border-bottom: 1px solid var(--color-stone-400);
        background: var(--color-stone-0);
        cursor: pointer;
        box-shadow:
            0px 1px 1px -0.5px var(--color-stone-200),
            0px 3px 3px -1.5px var(--color-stone-200);

        transition: all 0.3s ease-in-out;

        &:hover {
            background: var(--color-stone-200);
        }
    }

    &__input {
        width: 200px;
        height: 40px;
        border-top: 1px solid var(--color-stone-400);
        border-bottom: 1px solid var(--color-stone-400);
        border-left: none !important;
        border-right: none !important;
        border-radius: 0 !important;
    }
}
</style>
